/*
 *   Copyright (c) 2026 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from "graphql-tag";

export const GET_MY_TICKET_ORDERS = gql`
  query GetMyTicketOrders($boxId: ID) {
    getMyTicketOrders(boxId: $boxId) {
      ticketOrderId
      boxId
      feteId
      feteName
      feteStartsAt
      status
      releaseReason
      ticketAmount
      convenienceFee
      total
      currency
      holdExpiresAt
      lines {
        tierId
        tierName
        quantity
        unitPrice
        originalUnitPrice
        lineTotal
        feePerTicket
        lineFee
      }
      tickets {
        ticketId
        tierId
        tierName
      }
      viewTicketsUrl
      createdAt
    }
  }
`;
